import { render, staticRenderFns } from "./SkupoviNavigation.vue?vue&type=template&id=fed87f88&scoped=true&"
import script from "./SkupoviNavigation.vue?vue&type=script&lang=js&"
export * from "./SkupoviNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SkupoviNavigation.vue?vue&type=style&index=0&id=fed87f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed87f88",
  null
  
)

export default component.exports